const $_default =
{

}

const $_validator =
{

}

export default
{
    props:
    {
        monthDate       : { type: Date },
        localeData      : { type: Object },
        start           : { type: Date },
        end             : { type: Date },
        minDate         : { type: Date },
        maxDate         : { type: Date },
        showDropdowns   : { type: Boolean, default: false },
        showWeekNumbers : { type: Boolean, default: false },
        dateFormat      : { type: Function, default: null }
    }
}